// extracted by mini-css-extract-plugin
export var Banner = "style-module--Banner--f4411";
export var Category = "style-module--Category--599a3";
export var DescriptionWrapper = "style-module--DescriptionWrapper--93e87";
export var Image = "style-module--Image--488f0";
export var ImageWrapper = "style-module--ImageWrapper--5df29";
export var ServiceCard = "style-module--ServiceCard--3c39f";
export var Title = "style-module--Title--f0828";